import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SmartSoftButton } from "soft_digi";
import { USER_URLS } from "../../../api/Admin/AurhUrls";
import { useSiteContext } from "../../../contexts/SiteProvider";
import { ACCOUNT_SECURITY } from "../../../services/ImageService";
import { showAlertAutoClose } from "../../../services/notifyService";
import { post } from "../../../services/smartApiService";
// import SmartPassWord from "../../../components/site/FormElements/SmartPassWord";
import { SmartSoftForm, SmartValid } from "soft_digi";
// import {
//   VALID_PASSWORD_GENERAL,
//   VALID_PASSWORD,
// } from "../../../services/PatternSerivce.js";
import { ValidateFormNew } from "soft_digi/dist/services/smartValidationService";

const AccountSecurity = () => {
  const [formData, setFormData] = useState({});
  const [formSubmit, setFormSubmit] = useState(false);
  const [formErrors, setFormErrors] = useState(false);
  const [tab, setTab] = useState("security");
  const { setLoading } = useSiteContext();

  const navigate = useNavigate();
  const baseNav = "/account-settings";

  const navigateLink = (index) => {
    navigate(baseNav + "/" + index);
  };

  const handleInputChange = (name, value) => {
    //console.log(" name " ,name , "   value " , value)
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleErrorChange = (name, value) => {
    setFormErrors((prev) => {
      // Create a copy of the previous state
      const updatedFormData = { ...prev };
      // Check if the value is null or empty
      if (value === null || value === "") {
        // If true, remove the property from the updated state
        delete updatedFormData[name];
      } else {
        // Otherwise, update or add the property in the updated state
        updatedFormData[name] = value;
      }

      return updatedFormData;
    });
  };

  // const numericValidations = [
  //   {
  //     type: "required",
  //     msg: "Numeric Value is Required",
  //   },
  //   {
  //     type: "pattern",
  //     msg: "Please Enter Correct Numeric Value",
  //     pattern: "[0-9]+",
  //   },
  // ];

  const handleFormSubmit = () => {
    // console.log("formdata", formData);
    setFormSubmit(true);
    if (!ValidateFormNew(formData,Elements)) {
      return false;
    }
    const handleError = (errorMessage) => {
      showAlertAutoClose( errorMessage,"error");
      setLoading(false);
    };
    setLoading(true, "Details Submitting....Please Wait");
    // console.log(formData);
    let url = USER_URLS.CHANGE_PASSWORD;
    const subscription = post(url, formData, handleError).subscribe(
      (response) => {
        showAlertAutoClose( "Password Changed Successfully","success");
        setLoading(false);
        // console.log(response.data);
        setFormData({});
        setFormSubmit(false);
      }
    );
    return () => {
      subscription.unsubscribe();
    };
  };
  const tabs = [
    {
      index: "account",
      label: "Account",
      icon: <i className="fa fa-user-circle-o" aria-hidden="true"></i>,
      link: "account",
    },
    {
      index: "security",
      label: "Security",
      icon: <i className="fa fa-unlock-alt" aria-hidden="true"></i>,
      link: "security",
    },
  ];

  const handleTabs = (index) => {
    setTab(index);
  };

  const tabs_display = () => {
    return (
      <div className="tabs is-boxed is-medium is-8 crop-top-tabs account-settings-tab">
        <ul>
          {tabs.map((item, index) => {
            return (
              <li
                key={index}
                onClick={() => handleTabs(item.index)}
                className={tab === item.index ? "is-active" : ""}
              >
                <a href="#" onClick={() => navigateLink(item.link)}>
                  <span className={tab === item.index ? "is-active" : "account-settings-tab"}>{item.icon}</span>
                  <span className={tab === item.index ? "is-active ml-3" : "account-settings-tab ml-3"}>{item.label}</span>
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    );
  };
  const AccountSecurityFormValidations = {
    EnterOldPassword: [SmartValid.required("Old Password is Required")],
    EnterNewPassword: [SmartValid.required(" New Password is Required")],
    ConfirmNewPassword: [
      SmartValid.required("Confirm Password is Required"),
     
    ],

    // EnterOldPassword:[SmartValid.minLength("Number should be minimum 10 digit", 9)],
  };
  const Elements = [
    {
      type: "PASSWORD",
      width: "12",
      name: "currentPassword",
      element: {
        label: "Current Password",
        placeHolder: "Current Password",
        validations: AccountSecurityFormValidations.EnterOldPassword,
        inputType: "BORDER_LABEL",
        inputProps: { isFocussed: true },
        // max: 8,
        // pattern: VALID_PASSWORD_GENERAL,
      },
    },

    {
      type: "PASSWORD",
      width: "12",
      name: "newPassword",
      element: {
        label: "New Password",
        placeHolder: " New Password",
        validations: AccountSecurityFormValidations.EnterNewPassword,
        inputType: "BORDER_LABEL",
        inputProps: { isFocussed: true },
        max: 15,
        min:4
        // pattern: VALID_PASSWORD_GENERAL,
        // pattern: VALID_PASSWORD,
      },
    },

    {
      type: "PASSWORD",
      width: "12",
      name: "confirmPassword",
      element: {
        label: "Confirm Password",
        placeHolder: " Confirm Password",
        validations: AccountSecurityFormValidations.ConfirmNewPassword,
        inputType: "BORDER_LABEL",
        inputProps: { isFocussed: true },
        max: 15,
        min:4
        // min: 3,
        // pattern: VALID_PASSWORD,
      },
    },
  ];

  const Feild = () => {
   
    return (
      <div className="crop-admin-form account-settings-form">
        <div className="m-6">
          {/* <SmartSoftForm
            formData={formData}
            setFormData={handleInputChange}
            elements={Elements}
            formSubmit={formSubmit}
            handleErrorChange={handleErrorChange}
          /> */}
          <div className="pb-3 crop-admin-form">
            {/* <SmartPassWord
              key="currentPassword"
              name="currentPassword"
              value={formData?.currentPassword || ""}
              handleInputChange={handleInputChange}
              inputType="BORDER_LABEL_FOCUS"
              label="Enter Old Password"
              elements={Elements}
              passwordValidator={true}
              errorEnable={formSubmit}
              // min={8}
              // max={30}
              
              errorUpdate={(value) => handleErrorChange("euserid", value)}
              validations={AccountSecurityFormValidations.EnterOldPassword}
            /> */}
             <SmartSoftForm
            formData={formData}
            setFormData={handleInputChange}
            elements={Elements}
            formSubmit={formSubmit}
            handleErrorChange={handleErrorChange}
          />
          </div>
          <div className="pb-3">
            {/* <SmartPassWord
              key="newPassword"
              name="newPassword"
              inputType="BORDER_LABEL_FOCUS"
              label="Enter New Password"
              elements={Elements}
              value={formData?.newPassword || ""}
              handleInputChange={handleInputChange}
              passwordValidator={true}
              errorEnable={formSubmit}
              // min={8}
              // max={30}
              errorUpdate={(value) => handleErrorChange("euserid", value)}
              validations={AccountSecurityFormValidations.EnterNewPassword}
            /> */}
          </div>
          <div className="pb-3">
            {/* <SmartPassWord
              key="confirmPassword"
              name="confirmPassword"
              value={formData?.confirmPassword || ""}
              handleInputChange={handleInputChange}
              inputType="BORDER_LABEL_FOCUS"
              label="Confirm New Password"
              passwordValidator={true}
              elements={Elements}
              errorEnable={formSubmit}
              // min={8}
              // max={30}
              errorUpdate={(value) => handleErrorChange("euserid", value)}
              validations={AccountSecurityFormValidations.ConfirmNewPassword}
            /> */}
          </div>
          <div className="mt-6">
            <SmartSoftButton
              label="Save Change"
              onClick={() => handleFormSubmit()}
              classList={["smart-crop-admin-action-button", "px-6"]}
              // disabled={!isEmptyObject(formErrors)}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="smart-admin-crop-container is-mobile">
        <div key={"AccountSecurityFirstcolumns"} className="columns">
          <div key={"AccountSecurityFirstcolumn"} className="column ">
            {tabs_display()}
          </div>
        </div>

        <div key={"AccountSecuritySecondcolumns"} className="columns">
          <div key={"AccountSecuritySecondcolumn"} className="column is-6 ">
            {Feild()}
          </div>

          <div key={"AccountSecurityThirdcolumn"} className="column is-6  mb-5">
            <div className="card-image ">
              <img
                className="my-card-view-form-image"
                src={ACCOUNT_SECURITY}
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccountSecurity;
